import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getDynamicLanguageTraduora} from "./utilityI18n";
import configuration from "../../../configuration";

export const updateI18n = (lang: string, callback: any) => {
  if(i18n.languages.includes(lang)){
    callback()
  } else {
    getDynamicLanguageTraduora(lang).then((translation: any) => {
      i18n.addResourceBundle(lang, 'translation', translation)
      callback();
    })
  }
}

export const setI18n = (lang: string, callback: any) => {
  if(!(window as any).translate){
    (window as any).translate = {}
  }
  const initI18nActionInternal = (translation: any) => {
    i18n.use(initReactI18next).init({
      resources: {
        [lang]: {
          translation
        }
      },
      lng: lang,
      interpolation: {
        escapeValue: false,
      },
    }).then(load  => {
      configuration.configuration.lang = lang;
      callback && callback();
    })
  }
  if((window as any).translate[lang]){
    initI18nActionInternal((window as any).translate[lang])
  }else {
    getDynamicLanguageTraduora(lang).then(translation => {
      (window as any).translate[lang]=translation
      initI18nActionInternal(translation)
    })
  }

}


export default i18n
